import api from "../axiosInstance";

export const getMerchandiseProducts = async (payload) => {
  try {
    const response = await api.get(
      `/merchandiseProduct/?${payload.page ? `page=${payload.page}` : ""}&${
        payload.limit ? `limit=${payload.limit}` : ""
      }`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const createMerchandise = async (payload) => {
  try {
    const response = await api.post(`/merchandiseProduct/`, {
      productImage: payload.productImage,
      title: payload.title,
      categorie: payload.categorie,
      price: payload.price,
      description: payload.description,
      color: payload.color,
      size: payload.size,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const editMerchandise = async (payload) => {
  try {
    const payloadIs = {
      productImage: payload.productImage,
      title: payload.title,
      categorie: payload.categorie,
      price: payload.price,
      description: payload.description,
      color: payload.color,
      size: payload.size,
    };
    const response = await api.put(
      `/merchandiseProduct?id=${payload._id}`,
      payloadIs
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const deleteMerchandise = async (payload) => {
  try {
    const response = await api.delete(`/merchandiseProduct/?id=${payload._id}`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const getMerchandiseUsers = async (payload) => {
  try {
    const response = await api.get(
      `/merchandiseProduct/users?productId=${payload.productId}`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const addMerchandiseSales = async (payload) => {
  try {
    const response = await api.post(`/merchandiseProduct/sale`, {
      userId: payload.userId,
      merchandiseProductId: payload.merchandiseProductId,
      totalItem: Number(payload.totalItem),
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
